import { render, staticRenderFns } from "./internalMail.vue?vue&type=template&id=58a6d82d&"
import script from "./internalMail.vue?vue&type=script&lang=js&"
export * from "./internalMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/internalMail/internalMail.vue"
export default component.exports